import css from 'styled-jsx/css';
import { icons } from '../../../config/styles';
import { svgToDataUri } from '../../../utils/styles/svgMixins';

export const InternationalShippingStyles = css`
  /* Block: Main component */
  .international-shipping {
    display: flex;
    align-items: center;
    gap: 12px;
    line-height: 1.4;
  }

  /* Elements: Icon container and icon */
  .international-shipping__icon-container {
    flex-shrink: 0;
    display: flex;
    align-items: center;
  }

  .international-shipping__icon {
    display: block;
    width: 20px;
    height: 20px;
    background-image: url('${svgToDataUri(icons.aeroplaneRebranded)}');
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
  }

  /* Elements: Content container */
  .international-shipping__content {
    flex: 1;
    color: #333333;
  }

  /* Elements: Text container for inline layout */
  .international-shipping__text {
    display: inline;
    font-size: 12px;
    line-height: 1.4;
  }

  .international-shipping__description {
    color: #767676;
    -webkit-letter-spacing: 0.2px;
    -moz-letter-spacing: 0.2px;
    -ms-letter-spacing: 0.2px;
    letter-spacing: 0.2px;
    line-height: 16px;
    letter-spacing: 0;
    margin: 0 12px 0 0;
  }

  /* Elements: Button styling */
  .international-shipping__button {
    background: none;
    border: none;
    color: #767676;
    cursor: pointer;
    text-decoration: underline;
    font-size: 12px;
    font-weight: normal;
    line-height: 16px;
    transition: color 0.2s ease;
    letter-spacing: 0;
    margin-left: 0;
    padding: 0;
  }

  .international-shipping__button:hover {
    color: #000000;
    text-decoration: underline;
  }

  .international-shipping__button:focus {
    outline-offset: 2px;
  }

  /* Responsive design */
  @media screen and (max-width: 1023px) {
    .international-shipping {
      padding: 10px 12px;
      gap: 10px;
      margin-bottom: 12px;
    }

    .international-shipping__icon {
      width: 18px;
      height: 18px;
    }

    .international-shipping__button {
      font-size: 13px;
    }
  }

  /* Accessibility improvements */
  @media (prefers-reduced-motion: reduce) {
    .international-shipping__button {
      transition: none;
    }
  }

  @media (prefers-contrast: high) {
    .international-shipping__button {
      text-decoration-thickness: 2px;
    }
  }
`;
